import { render, staticRenderFns } from "./info_card.vue?vue&type=template&id=5046bdc0&scoped=true"
import script from "./info_card.vue?vue&type=script&lang=js"
export * from "./info_card.vue?vue&type=script&lang=js"
import style0 from "./info_card.vue?vue&type=style&index=0&id=5046bdc0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5046bdc0",
  null
  
)

export default component.exports